import { render, staticRenderFns } from "./structure.vue?vue&type=template&id=0db08a00&scoped=true&"
import script from "./structure.vue?vue&type=script&lang=js&"
export * from "./structure.vue?vue&type=script&lang=js&"
import style0 from "./structure.vue?vue&type=style&index=0&id=0db08a00&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db08a00",
  null
  
)

export default component.exports